import { OfflineBoltOutlined } from '@material-ui/icons';

const getPriorityPickupIcon = ({ className ="", ...props } ={}) => (
  <OfflineBoltOutlined className={className} {...props} />
);

export { getPriorityPickupIcon };
